import React, { Component } from 'react';
import Formulario from './InformesForm';

class Informes extends Component{
    componentDidMount = () => {
        const { getModulo, parametrosEmpresa } = this.props;
        let ruta = window.location.href;
        let modulo = ruta.split('/');
        getModulo(modulo[5],modulo[4]);
        parametrosEmpresa();
    }
    render(){
        const { loader, modulo, buscarPresupuesto,
            listarProyectosGestion, datos, 
            excelCosto, presupuestos } = this.props;
        return(
            <div>
                <Formulario
                    loader = {loader}
                    modulo = {modulo}
                    buscarPresupuesto = {buscarPresupuesto}
                    listarProyectosGestion = {listarProyectosGestion}
                    excelCosto = {excelCosto}
                    datos = {datos}
                    presupuestos = {presupuestos}
                />
            </div>
        );
    }
}

export default Informes;
